"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Scissors = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "scissors" },
            react_1.default.createElement("path", { id: "Icon", d: "M4.95368 7.70884C4.46151 7.45827 3.8594 7.65414 3.60884 8.14632C3.35827 8.63849 3.55414 9.2406 4.04632 9.49116L4.95368 7.70884ZM20.5463 17.8912C21.0385 18.1417 21.6406 17.9459 21.8912 17.4537C22.1417 16.9615 21.9459 16.3594 21.4537 16.1088L20.5463 17.8912ZM6 3V4V3ZM9 6H10H9ZM6 9V10V9ZM3 6H4H3ZM6 15V16V15ZM9 18H10H9ZM6 21V22V21ZM3 18H4H3ZM21.4537 7.89116C21.9459 7.6406 22.1417 7.03849 21.8912 6.54632C21.6406 6.05414 21.0385 5.85827 20.5463 6.10884L21.4537 7.89116ZM4.04632 14.5088C3.55414 14.7594 3.35827 15.3615 3.60884 15.8537C3.8594 16.3459 4.46151 16.5417 4.95368 16.2912L4.04632 14.5088ZM4.04632 9.49116L20.5463 17.8912L21.4537 16.1088L4.95368 7.70884L4.04632 9.49116ZM6 4C7.10457 4 8 4.89543 8 6H10C10 3.79086 8.20914 2 6 2V4ZM8 6C8 7.10457 7.10457 8 6 8V10C8.20914 10 10 8.20914 10 6H8ZM6 8C4.89543 8 4 7.10457 4 6H2C2 8.20914 3.79086 10 6 10V8ZM4 6C4 4.89543 4.89543 4 6 4V2C3.79086 2 2 3.79086 2 6H4ZM6 16C7.10457 16 8 16.8954 8 18H10C10 15.7909 8.20914 14 6 14V16ZM8 18C8 19.1046 7.10457 20 6 20V22C8.20914 22 10 20.2091 10 18H8ZM6 20C4.89543 20 4 19.1046 4 18H2C2 20.2091 3.79086 22 6 22V20ZM4 18C4 16.8954 4.89543 16 6 16V14C3.79086 14 2 15.7909 2 18H4ZM20.5463 6.10884L4.04632 14.5088L4.95368 16.2912L21.4537 7.89116L20.5463 6.10884Z" }))));
};
exports.default = Scissors;
